import { Route, Routes } from 'react-router-dom';
import { CalendarPage } from '@/modules/calendar/pages';

export function CalendarModule() {
  return (
    <Routes>
      <Route index element={<CalendarPage />} />
    </Routes>
  );
}
